module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_1000000.c20a7e84.png";